document.addEventListener('click', function (e) {
    const fila = e.target.closest('.trSelectEntregaLinea');
    if (!fila) return;

    const idLinea   = fila.dataset.id;
    const idReporte = fila.dataset.idReporte;

    const inputId      = document.getElementById('idLineaEntregaLineaEditar');
    const inputReporte = document.getElementById('idReporteSopladoEditarLinea');

    if (inputId)      inputId.value      = idLinea;
    if (inputReporte) inputReporte.value = idReporte;

    fetch(`/api/soplado/info-entrega-linea?idLine=${idLinea}`, {
        method: 'GET',
        credentials: 'include'
    })
    .then(r => r.json())
    .then(json => {
        const d = Array.isArray(json.result) ? json.result[0] : json.result;
        if (!d) return;

        const elNombre = document.getElementById('nombreLineaEditar');
        const elResponsable = document.getElementById('nombreResponsableLineaEditar');
        const elUnidades = document.getElementById('cantUnidadesLineaEditar');

        if (elNombre) elNombre.value = d.nombreLinea ?? '';
        if (elResponsable) elResponsable.value = d.nombreResponsableLinea ?? '';
        if (elUnidades) elUnidades.value = d.cantUnidades != null
            ? new Intl.NumberFormat('en-US').format(d.cantUnidades)
            : '';
    })
    .catch(err => console.error('Error al cargar entrega en línea:', err));
});

document.addEventListener('submit', function (e) {
    const form = e.target.closest('#formEditarEntregaLineaSoplado');
    if (!form) return;
    e.preventDefault();

    modal = form.closest('.modal');

    const btnSubmit = form.querySelector('[type="submit"]');
    if (btnSubmit) btnSubmit.disabled = true;

    const data = new FormData(form);

    fetch('/api/soplado/editar-entrega-linea', {
        method: 'POST',
        credentials: 'include',
        body: data
    })
    .then(r => r.json())
    .then(json => {
        const resultado = json.result ?? '';
        const errores = resultado.errores ?? [];
        errores.forEach(e => {
            lanzarAlerta(e.mensaje, e.clase);
            const campo = form.querySelector('[name="' + e.campo + '"]');
            if (campo) campo.classList.add('inputRojo');
        });

        if (!resultado.hayErrores) {
            const idReporte = document.getElementById('idReporteSopladoEditarLinea').value;
            form.reset();
            modal.classList.remove('modal--show');
            if (idReporte && typeof window.actualizarTablaEntregaLinea === 'function') {
                window.actualizarTablaEntregaLinea(idReporte);
            }
            if (typeof window.actualizarModalReporteSoplado === 'function') {
                window.actualizarModalReporteSoplado(idReporte);
            }
            if (typeof window.actualizarBalanceSoplado === 'function') {
                window.actualizarBalanceSoplado(idReporte);
            }
            lanzarAlerta('Entrega en línea actualizada correctamente.', 'alerta-verde');

        }
    })
    .catch(() => lanzarAlerta('Error al conectar con el servidor.', 'alerta-roja'))
    .finally(() => { if (btnSubmit) btnSubmit.disabled = false; });
});
